import { STRINGS } from '@/constants/farmerSolutions'

import VisitKisanAppButton from './VisitKisanAppButton'

const VisitWebsite = () => (
  <footer className="bg-yellow-20 flex flex-col pt-6 pb-5 px-6 font-natosans-semibold md:text-xl text-base max-w-[407px] rounded-lg">
    <p className="text-neutral-100 mb-4">{STRINGS.SIMPLE_WAY}</p>
    <VisitKisanAppButton />
  </footer>
)

export default VisitWebsite
